export {
  Tabs,
  TabsList,
  TabsTrigger,
  TabsContent,
} from '@tui-cruises/mein-schiff-web-react-component-library/src/components/core/Tabs';
